export default class EmptyStateController {
    /** @ngInject */
    constructor(TranslationService) {
        this.TranslationService = TranslationService;
    }

    $onInit() {
        const states = {
            'main.folders-and-labels.folders': {
                content: 'help_menu_main_folders-and-labels_folders',
                icon: 'fa-folder-open'
            },
            'main.folders-and-labels.labels': {
                content: 'help_menu_main_folders-and-labels_labels',
                icon: 'fa-tags'
            }
        };

        this.content = this.TranslationService.getLine(states[this.state].content);
        this.icon = states[this.state].icon;
    }
}



// WEBPACK FOOTER //
// ./app/common/empty-state/empty-state.controller.js